import * as React from "react";

export const OrganisationIcon = ({ opacity,isActive,...props }) => {
  return (
    <svg width={16} height={14} viewBox="0 0 16 14" fill="none" {...props}>
      <g
        opacity={opacity}
        stroke={isActive ? "#01A8CE" : "#214160"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12.834 3.5h-10c-.69 0-1.25.56-1.25 1.25V11c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V4.75c0-.69-.56-1.25-1.25-1.25z" />
        <path d="M10.334 12.25v-10A1.25 1.25 0 009.084 1h-2.5a1.25 1.25 0 00-1.25 1.25v10" />
      </g>
    </svg>
  );
};
